import { useState } from "react"
import { createFileRoute } from "@tanstack/react-router"
import AppLayout from "~/layouts/AppLayout"
import { Tabs, TabsList, TabsTrigger } from "@aix/ui"
import { ContentSourcesTab } from "~/components/Tools/components/ContentSourcesTab"
import { ScrapedContentTab } from "~/components/Tools/components/ScrapedContentTab"

function AdScraperPageWrapper() {
  return (
    <AppLayout>
      <AdScraperPage />
    </AppLayout>
  )
}

export const Route = createFileRoute("/tools/ad-scraper")({
  component: AdScraperPageWrapper,
})

function AdScraperPage() {
  const [activeTab, setActiveTab] = useState("sources")

  return (
    <div className="container mx-auto p-6 max-w-7xl">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-bold">Ad Scraper</h1>
      </div>

      <Tabs value={activeTab} onValueChange={setActiveTab}>
        <TabsList className="grid w-full grid-cols-2 mb-6">
          <TabsTrigger value="sources">Content Sources</TabsTrigger>
          <TabsTrigger value="content">Scraped Content</TabsTrigger>
        </TabsList>

        {activeTab === "sources" && <ContentSourcesTab />}
        {activeTab === "content" && <ScrapedContentTab />}
      </Tabs>
    </div>
  )
}
